import React from "react";

const Payment = () => {
  return (
    <div>
      <h1>Payment system coming soon...</h1>
    </div>
  );
};

export default Payment;
